import React from 'react';
import SvgIcon from './SvgIcon';

const FavoriteBlank = props => (
    <SvgIcon {...props}>
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
            <g transform="translate(-375.000000, -301.000000)" stroke="#565858">
                <g id="star" transform="translate(375.000000, 301.000000)">
                    <polygon
                        id="Path"
                        points="8 0.867 10.318 5.563 15.5 6.316 11.75 9.971 12.635 15.133 8 12.696 3.365 15.133 4.25 9.971 0.5 6.316 5.682 5.563"
                    ></polygon>
                </g>
            </g>
        </g>
    </SvgIcon>
);

FavoriteBlank.displayName = 'FavoriteBlankIcon';

export default FavoriteBlank;
